import { BrandKitMediaPriority } from 'types'
import { SegmentedControl } from 'blaze-ui/SegmentedControl/SegmentedControl'
import { Item } from '@react-stately/collections'

interface MediaPriorityToggleProps {
  value: BrandKitMediaPriority
  onChange: (value: BrandKitMediaPriority) => void
  isDisabled?: boolean
}

export const MediaPriorityToggle = ({ value, onChange, isDisabled = false }: MediaPriorityToggleProps) => {
  return (
    <SegmentedControl
      onItemClick={(selectedValue) => {
        if (!selectedValue) return
        onChange(selectedValue as BrandKitMediaPriority)
      }}
      activeItem={value}
      size="lg"
      variant="secondary"
      aria-label="Media priority selection"
      isDisabled={isDisabled}
    >
      <Item key="only_my_brand_kit" textValue="Use only my Images">
        Use only my Images
      </Item>
      <Item key="brand_kit_first" textValue="Most relevant to the post topic">
        Most relevant to the post topic
      </Item>
      <Item key="only_stock" textValue="Use only stock images">
        Use only stock images
      </Item>
    </SegmentedControl>
  )
}
